import { Component, Input } from "@angular/core";
import { User, userToString } from "../../../../../services/user/user.interface";
import { ClipboardService } from "ngx-clipboard";
import { UserRowClickEvent } from "../../../../../services/datatable/datatable.types";
import { NavigationService } from "../../../../../services/navigation/navigation.service";
import { tryParseDate } from "../../../../../services/utils/timestamp.utils";
import { capitalizeFirstLetter } from "../../../../../services/utils/string.utils";
import { SubscriptionStatus } from "../../../../../shared/backend-api.types";

@Component({
  selector: "rc-user-table",
  templateUrl: "./user-table.component.html",
  styleUrls: ["./user-table.component.scss"],
  standalone: false,
})
export class UserTableComponent {
  @Input() public users: (User & { subscriptionStatus?: SubscriptionStatus })[];
  @Input() public showSubscription: boolean = false;
  @Input() public showRole: boolean = false;

  constructor(
    private readonly clipboardService: ClipboardService,
    private readonly navigationService: NavigationService,
  ) {}

  public copyPhoneNumberToClipboard(user: User): void {
    this.clipboardService.copy(user.phone);
  }

  public getRowClass() {
    return { row: true };
  }

  public async goToUser(row: UserRowClickEvent) {
    if (row.type !== "click") {
      return;
    }

    await this.navigationService.goToUserDetailsPage(row.row.id);
  }

  protected readonly userToString = userToString;
  protected readonly tryParseDate = tryParseDate;
  protected readonly capitalizeFirstLetter = capitalizeFirstLetter;
}
